export const userProfile = {
  avatar: "https://readdy.ai/api/search-image?query=a%20modern%20minimalist%20profile%20avatar%20illustration%20of%20a%20young%20professional%20investor%20with%20confident%20expression%2C%20clean%20tech%20style%2C%20circular%20frame%20design%2C%20warm%20skin%20tones%20against%20soft%20gradient%20background%2C%20flat%20vector%20art%20with%20subtle%20shading%20in%20sophisticated%20color%20palette&width=200&height=200&seq=profile-avatar-01&orientation=squarish",
  nickname: "投资学习者007",
  uid: "AI20260528001",
  status: "active" as const,
  stats: {
    tradingDays: 128,
    achievements: 5,
    achievementsTotal: 9,
    totalReturnRate: 12.47,
  },
  menuItems: [
    { id: "reports", label: "收益报表 / 复盘", icon: "ri-bar-chart-grouped-line", path: "/reports" },
    { id: "strategy-config", label: "AI 策略配置", icon: "ri-settings-3-line", path: "/strategy-config" },
    { id: "strategy-select", label: "AI 策略选择", icon: "ri-brain-line", path: "/strategy-select" },
    { id: "notifications", label: "通知设置", icon: "ri-notification-3-line", path: "/notifications" },
    { id: "security", label: "安全设置", icon: "ri-shield-check-line", path: "/security" },
    { id: "achievements", label: "成就展示", icon: "ri-medal-line", path: "/achievements" },
    { id: "about", label: "关于 / 用户协议", icon: "ri-information-line", path: "/about" },
  ],
};

export const achievements = [
  { id: 1, name: "初次启航", description: "完成初始化向导并启动首个模拟盘", icon: "ri-rocket-2-line", unlocked: true, progress: 100 },
  { id: 2, name: "学习达人", description: "累计登录 30 天", icon: "ri-calendar-check-line", unlocked: true, progress: 100 },
  { id: 3, name: "风控先锋", description: "止损执行率达到 100%（至少 5 笔）", icon: "ri-shield-flash-line", unlocked: true, progress: 100 },
  { id: 4, name: "策略探索者", description: "至少体验过 3 种不同 AI 策略", icon: "ri-compass-3-line", unlocked: true, progress: 100 },
  { id: 5, name: "基本面猎手", description: "通过基本面分析研判盈利超 10%", icon: "ri-search-eye-line", unlocked: true, progress: 100 },
  { id: 6, name: "百单斩", description: "累计完成 100 笔模拟交易", icon: "ri-sword-line", unlocked: false, progress: 78 },
  { id: 7, name: "常胜将军", description: "连续 20 个交易日正收益", icon: "ri-trophy-line", unlocked: false, progress: 65 },
  { id: 8, name: "行业专家", description: "在 5 个不同行业实现盈利", icon: "ri-pie-chart-line", unlocked: false, progress: 60 },
  { id: 9, name: "AI 搭档", description: "与 AI 助手互动 100 次", icon: "ri-robot-2-line", unlocked: false, progress: 42 },
];

export const reportData = {
  periods: ["30天", "90天"],
  netValueCurve: [1.00, 1.03, 1.05, 1.02, 1.04, 1.08, 1.10, 1.07, 1.09, 1.12, 1.15, 1.13, 1.11, 1.1247],
  metrics: {
    totalReturn: 12.47,
    winRate: 62.5,
    maxDrawdown: -8.35,
    sharpe: 1.82,
    totalTrades: 78,
    winTrades: 49,
    loseTrades: 29,
  },
  stockContributions: [
    { name: "宁德时代", code: "300750", profit: 8220, rate: 9.2, type: "profit" as const },
    { name: "中际旭创", code: "300308", profit: 4340, rate: 19.6, type: "profit" as const },
    { name: "招商银行", code: "600036", profit: 2400, rate: 4.6, type: "profit" as const },
    { name: "比亚迪", code: "002594", profit: 1590, rate: 2.2, type: "profit" as const },
    { name: "贵州茅台", code: "600519", profit: 3200, rate: 1.9, type: "profit" as const },
    { name: "中芯国际", code: "688981", profit: -2320, rate: -5.3, type: "loss" as const },
    { name: "隆基绿能", code: "601012", profit: -1500, rate: -3.9, type: "loss" as const },
    { name: "药明康德", code: "603259", profit: -2460, rate: -7.8, type: "loss" as const },
  ],
  sectorDistribution: [
    { name: "新能源", percent: 28 },
    { name: "消费", percent: 22 },
    { name: "银行", percent: 15 },
    { name: "半导体", percent: 13 },
    { name: "光伏", percent: 10 },
    { name: "汽车", percent: 12 },
  ],
  monthlyWinRate: [
    { month: "1月", rate: 58 },
    { month: "2月", rate: 52 },
    { month: "3月", rate: 68 },
    { month: "4月", rate: 45 },
    { month: "5月", rate: 72 },
    { month: "6月", rate: 65 },
  ],
};